"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.form.title.edit': 'Editar Paquete de Precios',
    'accountGrade.form.title.add': 'Agregar Paquete de Precios',
    'accountGrade.form.back': 'Atrás',
    'accountGrade.form.name.label': 'Nombre',
    'accountGrade.form.name.placeholder': 'Nombre del paquete de precios',
    'accountGrade.form.description.label': 'Descripción',
    'accountGrade.form.description.placeholder': 'Descripción del paquete de precios',
    'accountGrade.form.price.label': 'Precio Mensual',
    'accountGrade.form.price.placeholder': 'Precio mensual (en USD)',
    'accountGrade.form.price.monthly.help': 'Precio de suscripción mensual en USD',
    'accountGrade.form.yearlyPrice.placeholder': 'Precio anual (en USD)',
    'accountGrade.form.yearlyPrice.help': 'Precio de suscripción anual en USD (normalmente con descuento)',
    'accountGrade.form.creditsPerMonth.placeholder': 'Número de créditos dados por mes',
    'accountGrade.form.creditsPerMonth.help': 'Los créditos se agregan automáticamente a las cuentas de usuario cada mes',
    'accountGrade.form.active.label': 'Activo',
    'accountGrade.form.active.description': 'Hacer disponible este paquete de precios',
    'accountGrade.form.order.label': 'Orden',
    'accountGrade.form.order.placeholder': 'Orden de visualización (opcional)',
    'accountGrade.form.submit.create': 'Crear Paquete de Precios',
    'accountGrade.form.submit.update': 'Actualizar Paquete de Precios',
    'accountGrade.form.save': 'Guardar Paquete de Precios',
    'accountGrade.form.saving': 'Guardando...',
    'accountGrade.form.unlimited': 'Ilimitado',
};
